import React from 'react';
import clsx from 'clsx';

import { BUTTON_STYLES } from '../common-button/CommonButton';
import Icon from '../../icons/Icon';

import './CommonButtonLink.scss';

const CommonButtonLink = ({
  onClick,
  children,
  disabled,
  styleColor = BUTTON_STYLES.PRIMARY,
  LeftIcon,
  ...buttonProps
}) => {
  return (
    <button
      className={clsx(
        'button-link',
        styleColor === BUTTON_STYLES.PRIMARY && 'button-link--primary',
        styleColor === BUTTON_STYLES.SECONDARY && 'button-link--secondary',
        styleColor === 'stressed' && 'button-link--stressed',
        styleColor === 'danger' && 'button-link--danger',
      )}
      disabled={disabled}
      onClick={onClick}
      {...buttonProps}>
      <span className='button-link_text'>
        {LeftIcon && (
          <Icon icon={LeftIcon} disableCommonColors disableCommonStyles currentColor className='button-link_icon' />
        )}
        {children}
      </span>
    </button>
  );
};

export default CommonButtonLink;
